/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { gql } from "@apollo/client";

export const GET_SESSION_SECRET = gql`
  query GetSessionSecret($getSessionSecretRequest: GetSessionSecretRequest!) {
    session(getSessionSecretRequest: $getSessionSecretRequest) {
      id
      created
      organization {
        name
        showProprietaryPopup
      }
      teacher {
        id
        firstName
        lastName
        email
        profileImgSmUrl
        title
        store {
          name
        }
      }
      learner {
        id
        firstName
        lastName
        email
        profileImgSmUrl
        title
        store {
          name
        }
      }
      skill {
        name
        titleTeacher
        titleLearner
      }
      teacherRating
      teacherSelfRating
      learnerRating
      learnerSelfRating
      masteryLevel
      masteryEdited
      allowSharing
      sessionSteps
      stepsReadyTeacher
      stepsReadyLearner
      archiveUrl
      transcriptionUrl
      hasTranscript
      isCancelled
    }
  }
`;
